export default {
  "brand.name": "AO3 Reader",
  "brand.short": "AO3",

  "nav.home": "Home",
  "nav.features": "Features",
  "nav.screenshots": "Screenshots",
  "nav.platforms": "Platforms",
  "nav.faq": "FAQ",
  "nav.download": "Download",
  "nav.login": "Log in",
  "nav.theme.toLight": "Switch to light mode",
  "nav.theme.toDark": "Switch to dark mode",
  "nav.lang": "中文",

  "hero.badge": "HOME | ARCHIVE OF OUR OWN",
  "hero.title": "Every story you love, in one beautiful reader",
  "hero.desc": "AO3 Reader brings the Archive of Our Own to Android, iOS, HarmonyOS and Windows — tag search, offline downloads and a reading view made for long nights and long fics.",
  "hero.ctaPrimary": "Download now",
  "hero.ctaSecondary": "See features",
  "hero.note": "Free · Android · iOS · HarmonyOS · Windows",
  "hero.stat1": "12M+ works",
  "hero.stat2": "500K+ readers",
  "hero.stat3": "4.9 rating",

  "stats.badge": "Loved by readers",
  "stats.works": "Works & stories",
  "stats.readers": "Active readers",
  "stats.rating": "Average rating",
  "stats.languages": "Languages",

  "features.badge": "Why AO3 Reader",
  "features.title": "Built for readers of the Archive",
  "features.subtitle": "Everything you need to follow your favourite fandoms, keep your place and read without distractions.",
  "features.items.reader.title": "AO3阅读器",
  "features.items.reader.desc": "A distraction-free reading mode with adjustable type, spacing and page turns — the AO3 reader built for binge-reading.",
  "features.items.offline.title": "Offline library",
  "features.items.offline.desc": "Download finished and ongoing works to read on a plane, a train, or anywhere the signal drops. Your library travels with you.",
  "features.items.sync.title": "Cross-device sync",
  "features.items.sync.desc": "Start a chapter on your phone and finish it on your laptop. Bookmarks, history and reading progress follow you everywhere.",
  "features.items.tags.title": "Tag & fandom search",
  "features.items.tags.desc": "Search by fandom, pairing, rating, warnings and free tags to find exactly the story you want to read tonight.",
  "features.items.night.title": "Day & night themes",
  "features.items.night.desc": "A warm paper light theme for daytime and a deep night theme that is easy on the eyes for late-night chapters.",
  "features.items.platforms.title": "Four platforms, one library",
  "features.items.platforms.desc": "One account and one library across Android, iOS, HarmonyOS and Windows — install once and read on any screen.",

  "screenshots.badge": "In the app",
  "screenshots.title": "A reader that feels handcrafted",
  "screenshots.subtitle": "Clean typography, a library that remembers where you stopped, and a night theme for the 3 a.m. chapters.",
  "screenshots.items.loading": "Launch screen",
  "screenshots.items.home": "AO3 home",
  "screenshots.items.search": "Search results",
  "screenshots.items.translate": "Translation tools",
  "screenshots.items.navigation": "Side menu",

  "platforms.badge": "Get the app",
  "platforms.title": "Available on every screen you own",
  "platforms.subtitle": "Pick your platform. The download buttons open the same quick picker, no matter where you tap.",
  "platforms.android.desc": "Phones & tablets",
  "platforms.ios.desc": "iPhone & iPad",
  "platforms.harmonyos.desc": "HarmonyOS phones & tablets",
  "platforms.windows.desc": "Desktop & laptop",
  "platforms.download": "Download",
  "platforms.android.caption": "Latest build · free download",
  "platforms.ios.caption": "Newest release · free install",
  "platforms.harmonyos.caption": "Rolling updates · free",
  "platforms.windows.caption": "Desktop edition · free use",

  "keywords.badge": "Trending searches",
  "keywords.title": "How readers find us",
  "keywords.subtitle": "These are the terms people search most when they look for the app and AO3.",

  "faq.badge": "Good to know",
  "faq.title": "Frequently asked questions",
  "faq.subtitle": "Short answers to the things readers ask us most.",
  "faq.items.what.q": "What is AO3 Reader?",
  "faq.items.what.a": "AO3 Reader is a companion app for reading works published on the Archive of Our Own (AO3). It is made and maintained by fans and is not officially affiliated with the Organization for Transformative Works.",
  "faq.items.free.q": "Is AO3 Reader really free?",
  "faq.items.free.a": "Yes. The app is free to download and use on Android, iOS, HarmonyOS and Windows. There is no paywall between you and the stories you want to read.",
  "faq.items.hostError.q": "How do I fix the AO3.CUBEART.CLUB HOST ERROR?",
  "faq.items.hostError.a": "That message appears when a mirror or third-party host is temporarily unreachable. Update to the latest build, clear the in-app cache, then use the official download buttons on this page to reinstall a working client.",
  "faq.items.platforms.q": "Which platforms are supported?",
  "faq.items.platforms.a": "Android, iOS, HarmonyOS and Windows. Tap any download button on this page and pick the build for your device.",
  "faq.items.entry.q": "Where is the AO3链接入口?",
  "faq.items.entry.a": "The AO3链接入口 is the direct entry into AO3 from inside the app. Open the app and tap the compass icon in the bottom bar to land straight on the AO3 feed.",

  "cta.badge": "AO3阅读器",
  "cta.title": "A quieter place to read",
  "cta.desc": "Join hundreds of thousands of readers who take AO3 everywhere. Download AO3 Reader for Android, iOS, HarmonyOS or Windows.",
  "cta.button": "Download AO3 Reader",
  "cta.entry": "AO3链接入口",
  "cta.entryNote": "Open AO3 from inside the app",

  "modal.title": "Download AO3 Reader",
  "modal.subtitle": "Choose your platform to get the latest build.",
  "modal.close": "Close",
  "modal.opening": "Opening download…",
  "modal.login": "Log in",

  "footer.desc": "AO3 Reader is a fan-made reading app for the Archive of Our Own.",
  "footer.navTitle": "Explore",
  "footer.contactTitle": "Contact us",
  "footer.rights": "All rights reserved.",
};